import { AlertTriangle } from 'lucide-react';
import type { CapturedIdea } from '../../lib/capturedIdeas';

interface Props {
  idea: CapturedIdea;
  onClose: () => void;
  onConfirm: (id: string) => Promise<void>;
}

export function DeleteIdeaModal({ idea, onClose, onConfirm }: Props) {
  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-2xl p-6 w-full max-w-md text-center">
        <AlertTriangle className="w-10 h-10 text-red-500 mx-auto mb-3" />
        <h2 className="text-lg font-bold text-[#231F20] mb-2">Idee verwijderen?</h2>
        <p className="text-gray-600 mb-6">"{idea.title}" wordt definitief verwijderd. Dit kan niet ongedaan worden gemaakt.</p>
        <div className="flex justify-center gap-2">
          <button onClick={onClose} className="btn-secondary">Annuleer</button>
          <button onClick={() => onConfirm(idea.id)} className="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700">Verwijderen</button>
        </div>
      </div>
    </div>
  );
}
